<template>
  <p class="text-h6 mb-6">
    {{ $t("component.notFoundModel.introQuestion") }}
  </p>
  <v-btn block color="primary" class="mb-3" @click="emit('yes')">
    {{ $t("component.notFoundModel.introYes") }}
  </v-btn>
  <v-btn block color="primary" variant="outlined" @click="emit('no')">
    {{ $t("component.notFoundModel.introNo") }}
  </v-btn>
</template>

<script setup lang="ts">
const emit = defineEmits<{ yes: []; no: [] }>();
</script>
